/**
 * The review bar as a person would state it, for Paige's setup overview (SetupOverview), from the bars in force:
 * each field can carry its own, so a line quoting the job's policy could name a number no field uses. CapturePoint
 * removed its copy with its own overview (its 31cd71e0 and the review chunks after it); the overview is Paige's.
 */
type ReviewPolicyType = {
  status: string;
  fields: readonly { kind: string; reviewBelow?: number | null }[];
};

/** Same sensitivity units as the policy editor, not a calibrated accuracy claim. */
export function reviewPolicySummary(
  types: readonly ReviewPolicyType[],
  policy: { fields?: number | null; fieldsEnabled?: boolean } | null | undefined,
  defaultFieldThreshold: number,
): string {
  if (policy?.fieldsEnabled === false) return 'Field confidence checks off';
  const thresholds = types
    .filter((type) => type.status !== 'archived')
    .flatMap((type) => type.fields)
    .filter((field) => field.kind !== 'line-items' && field.kind !== 'document-type')
    .map((field) => field.reviewBelow ?? policy?.fields ?? defaultFieldThreshold);
  if (!thresholds.length) thresholds.push(policy?.fields ?? defaultFieldThreshold);
  if (thresholds.some((value) => !Number.isFinite(value) || value < 0 || value > 1))
    return 'Review holds on · field threshold unavailable';
  const low = Math.round(Math.min(...thresholds) * 100);
  const high = Math.round(Math.max(...thresholds) * 100);
  if (thresholds.every((value) => value === 0))
    return 'Review holds on · validation checks only for fields';
  return low === high
    ? `Field threshold ${high} / 100`
    : `Field threshold ${low}–${high} / 100 · varies by field`;
}
